module.exports = __webpack_public_path__ + "img/r-brooke-lark-96398-unsplash-min-460x295.181fc275.jpg";